import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

// Define a service using a base URL and expected endpoints
export const parentSliceApi = createApi({
  baseQuery: fetchBaseQuery({ baseUrl: 'http://13.234.114.213:8000/' }),
  endpoints: (builder) => ({
    accountDelete: builder.mutation({
        query: (requestBody) => ({
          url: 'get-otp-delete-parent-profile',
          method: 'POST',
          body: requestBody,
        })
    }),
    deleteParentProfile: builder.mutation({
        query: (requestBody) => ({
          url: 'delete-parent-profile',
          method: 'POST',
          body: requestBody,
        })
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useAccountDeleteMutation, 
    useDeleteParentProfileMutation } = parentSliceApi